import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';

import { ReactComponent as Icon } from '@/assets/icons/info-badge-grey.svg';

// @TODO : Duplication with src/views/ShoppingBagView/components/ShoppingBagStrapDrawer/components/ShoppingBagStrapDetails/ShoppingBagStrapDetails.styles.tsx -> BucklesWrapper
export const BucklesWrapper = styled(Box)<{ $nbBuckles: number }>`
  ${({ $nbBuckles, theme }) => css`
    display: ${$nbBuckles > 1 ? 'grid' : 'block'};
    justify-content: center;
    grid-template-columns: auto auto auto auto;
    margin-bottom: ${({ theme }) => theme.spacing(3)};
    gap: ${theme.spacing(0.5)};
  `}
`;

export const NoBuckles = styled(Flex)`
  ${({ theme }) => css`
    background-color: ${theme.colors.feedbackHighLight};
    justify-content: center;
    padding: ${theme.spacing(1, 0)};
    font-size: ${theme.fontSizes.p2};
    line-height: ${theme.lineHeights.p2};
    margin-bottom: ${theme.spacing(2)};
  `}
`;

export const InfoBadge = styled(Icon)`
  ${({ theme }) => css`
    margin-right: ${theme.spacing(1)};
  `}
`;
